import React from 'react';
import ContactContent from './Components';

const ContactPage: React.FC = () => {
  return <ContactContent />;
};

export default ContactPage;
